import { configureStore } from "@reduxjs/toolkit";
import signSlice from "../Slices/SignSlice";

export const store = configureStore({
    reducer: {
        sign: signSlice
    }
});